module.exports = __webpack_public_path__ + "img/77358.f22e1ef9.svg";